import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SignOffReportService } from "src/app/services/sign-off-report.service";

@Component({
  selector: "app-secure-signoff-report-au",
  templateUrl: "./signoff-report-au.component.html",
  styleUrls: ["./signoff-report-au.component.scss"],
})
export class SignOffReportAUComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  reportTypes: string[];
  selectedFile: File;
  
  constructor(
    private signOffReportService: SignOffReportService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.signOffReportService
    .initForm()
    .subscribe((data) => {
      if(data.status === 'SUCCESS') {
        this.reportTypes = data.reportTypes;
      }
      else {
        this.errorToast(data.errorMessage, 5*1000);
      }
    });
    this.form = new FormGroup({
      reportName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      reportType: new FormControl(null, [Validators.required]),
      reportFile: new FormControl(null, Validators.required),
      signerLst: new FormArray([])
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.save();
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
  }

  async save() {
    const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.signOffReportService
        .createRequest(this.form.value.reportType, {
          reportName: this.form.value.reportName,
          base64File: reader.result,
          list: this.form.value.signerLst.map(ur => ({
            signerName: ur.signerName,
            signerMailId: ur.signerMailId,
            xcoord: ur.xcoord,
            ycoord: ur.ycoord,
          }))
        })
        .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.successToast();
            this.router.navigate(["/secure", "signoff-report", "list"]);
          }
          else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        }, error => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5*1000);
        });  
    };
  }

  async successToast() {
    await this._snackBar.open(
      "Sign-off request created successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showBDD(o1: any, o2: any) {    
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  addSigner() {
    let selectedSignerLst: FormArray = this.form.get('signerLst') as FormArray;
    selectedSignerLst.push(new FormGroup({
      signerName: new FormControl(null, Validators.required),
      signerMailId: new FormControl(null, Validators.required),
      xcoord: new FormControl(null, Validators.required),
      ycoord: new FormControl(null, Validators.required)
    }));
  }

  deleteSigner(i: number) {
    let selectedSignerLst: FormArray = this.form.get('signerLst') as FormArray;
    selectedSignerLst.removeAt(i);
  }

  get signers() {
    return this.form.get('signerLst')['controls'];
  }

}